interface Props {
  type: string | null | undefined;
  size?: number;
  className?: string;
}

export default function LibraryTypeIcon({ type, size = 14, className }: Props) {
  const stroke = "currentColor";
  switch (type) {
    case "video":
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" className={className}>
          <rect x="2" y="3" width="10" height="8" rx="1.5" fill="none" stroke={stroke} strokeWidth="1.3" />
          <path d="M6 5.5l3 1.5-3 1.5z" fill={stroke} />
        </svg>
      );
    case "course":
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" className={className}>
          <path d="M2 5l5-2 5 2-5 2z" fill="none" stroke={stroke} strokeWidth="1.3" strokeLinejoin="round" />
          <path d="M4 6.5v3.2c0 0.7 1.3 1.3 3 1.3s3-0.6 3-1.3V6.5" fill="none" stroke={stroke} strokeWidth="1.3" />
        </svg>
      );
    case "podcast":
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" className={className}>
          <circle cx="7" cy="6" r="2.2" fill="none" stroke={stroke} strokeWidth="1.3" />
          <path d="M4 8c-0.6-0.6-1-1.4-1-2.4a4 4 0 018 0c0 1-0.4 1.8-1 2.4" fill="none" stroke={stroke} strokeWidth="1.3" />
          <path d="M7 8.5v3.5" stroke={stroke} strokeWidth="1.3" strokeLinecap="round" />
        </svg>
      );
    case "note":
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" className={className}>
          <path d="M3 2h6l3 3v7H3z" fill="none" stroke={stroke} strokeWidth="1.3" />
          <path d="M9 2v3h3" fill="none" stroke={stroke} strokeWidth="1.3" />
        </svg>
      );
    case "link":
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" className={className}>
          <path d="M5 9l4-4M4 6h2M8 8h2" fill="none" stroke={stroke} strokeWidth="1.3" strokeLinecap="round" />
          <circle cx="4" cy="9" r="2" fill="none" stroke={stroke} strokeWidth="1.3" />
          <circle cx="10" cy="5" r="2" fill="none" stroke={stroke} strokeWidth="1.3" />
        </svg>
      );
    case "quote":
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" className={className}>
          <path d="M3 4q0-2 2-2v2q-1 0-1 1v3H3zM8 4q0-2 2-2v2q-1 0-1 1v3H8z" fill={stroke} />
        </svg>
      );
    case "article":
    default:
      return (
        <svg width={size} height={size} viewBox="0 0 14 14" className={className}>
          <path d="M3 2h6l2 2v8H3z" fill="none" stroke={stroke} strokeWidth="1.3" />
          <path d="M5 6h4M5 8h4M5 10h3" stroke={stroke} strokeWidth="1" strokeLinecap="round" />
        </svg>
      );
  }
}
